import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { FormattedMessage } from 'react-intl';
import { FulfillmentPlanOrderGridStatus } from '../../../enums/fulfillmentplan-order-grid-status';
import { messages } from './messages';

const StatusComponent = ({ fulfillmentPlanId }) => {
  const orderGridStatus = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'orderGridStatus',
    }),
  );

  if (!orderGridStatus) {
    return '';
  }
  const translatedStatus = FulfillmentPlanOrderGridStatus[orderGridStatus]?.translation;

  return translatedStatus ? <FormattedMessage {...translatedStatus} /> : '';
};

StatusComponent.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const Status = {
  getMessageDescriptor: () => messages.status,
  id: 'status',

  render: (data) => {
    return <StatusComponent fulfillmentPlanId={data.id} />;
  },
};
